import React from "react";

const Exit = ({ color = "black" }: { color?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
    >
      <path
        d="M3.75 11.5V14C3.75 15.3807 4.86929 16.5 6.25 16.5H13.75C15.1307 16.5 16.25 15.3807 16.25 14V4C16.25 2.61929 15.1307 1.5 13.75 1.5H6.25C4.86929 1.5 3.75 2.61929 3.75 4V6.5"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.75 11.5L11.25 9L8.75 6.5"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.25 9H11.25"
        stroke={color}  
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Exit;
